// extracted by mini-css-extract-plugin
export default {"Breadcrumb":"index-module--Breadcrumb--X3nOr","Breadcrumb__item":"index-module--Breadcrumb__item---Ef3Y","Breadcrumb__link":"index-module--Breadcrumb__link--YXgQ+"};